export default __webpack_public_path__ + "static/media/location.4ba2450b.png";